import * as React from "react";
import { useFieldState, useFieldApi, useField } from "informedv4";
import { inputClasses } from "../validation/ValidationClasses";
import { omit } from "lodash";

export const TextBoxWithStaticPrefix = ({ field, name, id, type, ...rest }) => {

    const fieldName = field ?? name;
    if (!fieldName) {
        throw new Error("TextBox requires either `field` or `name`.");
    }

    const { error } = useFieldState(fieldName);

    const { fieldApi, fieldState, ref, userProps } = useField({
        type: type,
        name: fieldName,
        validate: rest.validate,
        initialValue: rest.initialValue,
        required: rest.required,
    });

    const safeRest = omit(rest, [
        'value',
        'defaultValue',
        'onChange',
        'onBlur',
        'validate',
        'validateOn',
        'initialValue',
        'required',
        'field',
    ]);

    return (
        <>
            <div className="input-group">
                <span className="input-group-addon">{rest.staticpart}</span>
                <input
                    id={id}
                    name={name}
                    type={type}
                    ref={ref}
                    onChange={e => fieldApi.setValue(e.target.value)}
                    value={String(fieldState.value ?? '')}
                    className={inputClasses(error as string)}
                    {...safeRest}
                    {...userProps}
                />
            </div>
            {fieldApi.getError() ? <span className="field-validation-error">{fieldApi.getError() as string}</span> : null}
        </>
    );
}
